import animateCSS from "./animations";

export function get(path, obj) {
  return path.reduce((xs, x) => (xs == null || xs[x] == null ? null : xs[x]), obj);
}

export function renderValidationErrors(event, form, prefix) {
  form.querySelectorAll("span.error").forEach((node) => node.remove());
  const errors = get(["detail", 0, "errors"], event);
  if (!errors || typeof errors !== "object" || Array.isArray(errors)) return false;

  let rendered = false;
  for (const [key, messages] of Object.entries(errors)) {
    const field = document.getElementById(`${prefix}_${key}`);
    const message = Array.isArray(messages) ? messages[0] : messages;
    if (!field || !form.contains(field) || typeof message !== "string") continue;
    const error = document.createElement("span");
    error.classList.add("error");
    error.setAttribute("role", "alert");
    error.textContent = message;
    field.after(error);
    rendered = true;
  }
  return rendered;
}

export function showRequestError(kind) {
  const region = document.getElementById("requestError");
  if (!region) return;
  region.textContent = region.dataset[kind] || region.dataset.server;
  region.hidden = false;
}

export function registerRequestErrorHandler() {
  document.addEventListener("ajax:beforeSend", () => {
    const region = document.getElementById("requestError");
    if (region) region.hidden = true;
  });
  document.addEventListener("ajax:error", (event) => {
    if (event.validationErrorsRendered) return;
    const xhr = get(["detail", 2], event);
    const status = xhr ? xhr.status : 0;
    let kind = "server";
    if (status === 0) kind = "network";
    else if (status === 401 || status === 403) kind = "authorization";
    else if (status === 422) kind = "validation";
    showRequestError(kind);
  });
}

export function showFlashMessages() {
  const node = document.getElementById("flashMessages");
  if (node !== null && typeof node !== "undefined" && node.hasChildNodes()) {
    Array.from(node.childNodes).forEach((elem) => {
      if (elem.nodeType === Node.ELEMENT_NODE) {
        node.style.removeProperty("display");
      }
    });

    animateCSS("#flashMessages", "fadeOut", (node, _animatonName) => {
      node.style.display = "none";
    });
  }
}
